import { CSSProperties, PropsWithChildren } from 'react'
import css from './statisticsCard.module.css'
import QuestionIconWithTooltip from '@/shared/Common/QuestionIconWithTooltip'

interface IProps {
  heading: string
  style?: CSSProperties
  tooltipText?: string
}

const StatisticsCard = (props: PropsWithChildren<IProps>) => {
  return (
    <div className={`flex-lines ${css.wrapper}`} style={props.style}>
      <div className="flex-space-between gap8">
        <p className="text-nm text-secondary">{props.heading}</p>
        {props.tooltipText && <QuestionIconWithTooltip text={props.tooltipText} position="right" />}
      </div>
      {props.children}
    </div>
  )
}

export default StatisticsCard
